/**
 * 侧边栏菜单配置（与路由 path 对应，通过 router-link / router.push 导航）
 */

/** 工作台（固定首页，不在分组内） */
export const dashboardMenu = {
  id: 'dashboard',
  title: '工作台',
  icon: '⌂',
  to: '/'
}

export const menuGroups = [
  {
    id: 'check',
    title: '检查列表',
    icon: '◫',
    children: [
      { title: '检查任务', to: '/center/biochemistry', requireLoginType: true },
      { title: '医生接诊', to: '/biochemistry/medicineIndex' },
      { title: 'MDT多学科会诊申请', to: '/consultation/index', requireLoginType: true },
      { title: '图文问诊', to: '/center/imageTextInquiry', requireLoginType: true, hidden: true },
      { title: '常用短语管理', to: '/center/phrase' }
    ]
  },
  {
    id: 'doctor',
    title: '医生管理',
    icon: '★',
    children: [
      { title: '医生工作站', to: '/workstation/prescription' },
      { title: '处方查询', to: '/workstation/queryPrescription' },
      { title: '协定方', to: '/workstation/clinicalgroup' },
      { title: '推荐商品', to: '/doctor/recommendedProducts' },
      { title: '菌群移植', to: '/center/microbiota' }
    ]
  },
  {
    id: 'pharmacy',
    title: '药房管理',
    icon: '▣',
    requireLoginType: true,
    children: [
      { title: '处方开具', to: '/workstation/prescriptionAudit' },
      { title: '处方查询', to: '/workstation/prescriptionInquiry' }
    ]
  }
]

/** 非菜单项路由 -> 所属分组（用于侧边栏高亮） */
const extraPathGroups = {
  '/center/chat': 'check',
  '/center/trtc': 'check',
  '/center/mq': 'check',
  '/center/pdf': 'check',
  '/doctor/productSelection': 'doctor',
  '/doctor/recommended-management': 'doctor',
  '/clinic/medicalRecord': 'doctor'
}

/** 根据 path 判断所属菜单分组 */
export function menuGroupIdForPath(path) {
  if (path === '/' || path === dashboardMenu.to) {
    return dashboardMenu.id
  }
  if (extraPathGroups[path]) {
    return extraPathGroups[path]
  }
  for (let i = 0; i < menuGroups.length; i++) {
    const group = menuGroups[i]
    for (let j = 0; j < group.children.length; j++) {
      if (group.children[j].to === path) {
        return group.id
      }
    }
  }
  return null
}

/** loginType 是否包含中心端权限 digit */
export function hasLoginTypeDigit(loginType, digit) {
  if (digit === undefined || digit === null) return true
  const list = String(loginType || '').split(',')
  return list.indexOf(String(digit)) !== -1
}

export function hasLoginTypeFlag(loginType) {
  return hasLoginTypeDigit(loginType, '1')
}



// WEBPACK FOOTER //
// ./src/router/menus.js